<div class="flex flex-column align-items-center align-content-center gap-4 my-5 m-auto w-10">
    <h3>Crear nuevo artículo</h3>
    <form [formGroup]="articleForm" (ngSubmit)="createArticle()"
        class="flex flex-column gap-2 align-items-center w-10 m-auto">
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <input id="urlId" type="text" pInputText class="p-inputtext-lg w-full" formControlName="urlId"
                    maxlength="100" autofocus="true"
                    [class.ng-invalid]="this.articleForm.get('urlId')?.invalid && this.articleForm.get('urlId')?.touched" />
                <label htmlFor="urlId">Identificador para la URL</label>
            </span>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <input id="title" type="text" pInputText class="p-inputtext-lg w-full" formControlName="title"
                    maxlength="300"
                    [class.ng-invalid]="this.articleForm.get('title')?.invalid && this.articleForm.get('title')?.touched" />
                <label htmlFor="title">Título</label>
            </span>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <input id="metaTitle" type="text" pInputText class="p-inputtext-lg w-full" formControlName="metaTitle"
                    maxlength="300"
                    [class.ng-invalid]="this.articleForm.get('metaTitle')?.invalid && this.articleForm.get('metaTitle')?.touched" />
                <label htmlFor="metaTitle">Meta título</label>
            </span>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <textarea rows="5" cols="30" id="summary" pInputTextarea class="p-inputtext-lg w-full" formControlName="summary" maxlength="300"
                    [class.ng-invalid]="this.articleForm.get('summary')?.invalid && this.articleForm.get('summary')?.touched">
                </textarea>
                <label htmlFor="summary">Resumen</label>
            </span>
            <label class="contador">{{ this.articleForm.get('summary')?.value.length }}/300</label>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <textarea rows="5" cols="30" id="metaDescription" pInputTextarea class="p-inputtext-lg w-full" formControlName="metaDescription" maxlength="300"
                    [class.ng-invalid]="this.articleForm.get('metaDescription')?.invalid && this.articleForm.get('metaDescription')?.touched">
                </textarea>
                <label htmlFor="metaDescription">Meta descripción</label>
            </span>
            <label class="contador">{{ this.articleForm.get('metaDescription')?.value.length }}/300</label>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <input id="image" type="text" pInputText class="p-inputtext-lg w-full" formControlName="image"
                    maxlength="1000"
                    [class.ng-invalid]="this.articleForm.get('image')?.invalid && this.articleForm.get('image')?.touched" />
                <label htmlFor="image">Imagen</label>
            </span>
        </div>
        <div class="field my-3 w-full">
            <span class="p-float-label">
                <input id="author" type="text" pInputText class="p-inputtext-lg w-full" formControlName="author"
                    maxlength="45"
                    [class.ng-invalid]="this.articleForm.get('author')?.invalid && this.articleForm.get('author')?.touched" />
                <label htmlFor="author">Autor</label>
            </span>
        </div>
        <div class="flex flex-column gap-1">
            <p-checkbox formControlName="visible" label="Será visible inmediatamente" styleClass="mx-2"
                [binary]="true" inputId="visible" />
        </div>
        <div class="flex flex-column gap-1">
            <label htmlFor="articleType" style="font-size: 12px;">Tipo de artículo</label>
            <p-selectButton id="articleType" [options]="articleTypeList" formControlName="articleType" 
                optionLabel="description" ></p-selectButton>
        </div>
        <div class="flex flex-column gap-1 w-full">
            <label htmlFor="content">Contenido del artículo</label>
            <!--p-editor id="content" styleClass="w-full" formControlName="content" [style]="{ height: '500px' }"></p-editor-->
        </div>
        <p-button label="Guardar" type="submit" [loading]="loading"></p-button>
    </form>
</div>